const animation = require("./plusOne.json");

module.exports = {
    loop: false,
    autoplay: true,
    prerender: true,
    renderer: "svg",
    animationData: animation,
}